export const NOT_AVAILABLE = 'n/a';
export const DEFAULT = 'DEFAULT';

export default {
  NOT_AVAILABLE,
  DEFAULT,
};
